/* eslint-disable react-hooks-extra/no-direct-set-state-in-use-effect */
import type { PopoverContentProps, PopoverProps, PopoverTriggerProps } from '@connected/ui/components/popover';

import { Popover, PopoverContent, PopoverTrigger } from '@connected/ui/components/popover';
import { useEffect, useState } from 'react';

import type { PrimitiveValueType } from '../../lib/utils';

import { useFieldContext } from '../../hooks/use-form-context';

export type PopoverFieldProps = Omit<PopoverProps, 'onOpenChange' | 'open'> & {
    closeOnChange?: boolean;
};

export function PopoverField(props: PopoverFieldProps) {
    const { closeOnChange = false, ...restProps } = props;

    const [open, setOpen] = useState(false);

    const field = useFieldContext<PrimitiveValueType>();

    useEffect(() => {
        if (field.state.value && closeOnChange) {
            setOpen(false);
        }
    }, [field.state.value, closeOnChange]);

    return <Popover open={open} onOpenChange={setOpen} {...restProps} />;
}

PopoverField.displayName = 'PopoverField';

export type PopoverFieldContentProps = PopoverContentProps;

function PopoverFieldContent(props: PopoverFieldContentProps) {
    return <PopoverContent {...props} />;
}

PopoverFieldContent.displayName = 'PopoverFieldContent';
PopoverField.Content = PopoverFieldContent;

export type PopoverFieldTriggerProps = PopoverTriggerProps;

function PopoverFieldTrigger(props: PopoverFieldTriggerProps) {
    const field = useFieldContext<PrimitiveValueType>();

    return <PopoverTrigger {...props} id={field.name} />;
}

PopoverFieldTrigger.displayName = 'PopoverFieldTrigger';
PopoverField.Trigger = PopoverFieldTrigger;
